import { HttpService } from "@/shared/http.service";

export class AppService {
  $http = new HttpService();

  constructor() {
  }

  async getChatwoot() {
    const response = this.$http.get(`api/chatwoot`);
    return response ?? {};
  }
}